import Vue from 'vue'

import { library } from '@fortawesome/fontawesome-svg-core'

import {
  faAngleDown,
  faAngleUp,
  faArrowsAltV,
  faBars,
  faBold,
  faCaretLeft,
  faCaretRight,
  faCheck,
  faCheckCircle,
  faCheckSquare,
  faCircle,
  faClock,
  faCloudUploadAlt,
  faDatabase,
  faDollarSign,
  faEnvelope,
  faExclamationTriangle,
  faImage,
  faInfoCircle,
  faItalic,
  faLink,
  faLock,
  faMinusCircle,
  faMobile,
  faPaperPlane,
  faPauseCircle,
  faPlayCircle,
  faPlusCircle,
  faQuestionCircle,
  faSave,
  faSortDown,
  faSortUp,
  faSquare,
  faStrikethrough,
  faTimes,
  faTimesCircle,
  faUnderline,
  faUnlink,
} from '@fortawesome/free-solid-svg-icons'

import {
  faAddressCard,
  faCalendarPlus,
  faCamera,
  faClone,
  faComments,
  faCopy,
  faEye,
  faFileExcel,
  faFileWord,
  faHistory,
  faImagePolaroid,
  faMehBlank,
  faPen,
  faPrint,
  faSignOutAlt,
  faSortAmountDownAlt,
  faToggleOff,
  faToggleOn,
  faTrash,
  faUser,
  faUserFriends,
  faUserTie,
} from '@fortawesome/pro-duotone-svg-icons'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(
  faAddressCard,
  faAngleDown,
  faAngleUp,
  faArrowsAltV,
  faBars,
  faBold,
  faCalendarPlus,
  faCamera,
  faCaretLeft,
  faCaretRight,
  faCheck,
  faCheckCircle,
  faCheckSquare,
  faCircle,
  faClock,
  faClone,
  faCloudUploadAlt,
  faComments,
  faCopy,
  faDatabase,
  faDollarSign,
  faEnvelope,
  faExclamationTriangle,
  faEye,
  faFileExcel,
  faFileWord,
  faHistory,
  faImage,
  faImagePolaroid,
  faInfoCircle,
  faItalic,
  faLink,
  faLock,
  faMehBlank,
  faMinusCircle,
  faMobile,
  faPaperPlane,
  faPauseCircle,
  faPen,
  faPlayCircle,
  faPlusCircle,
  faPrint,
  faQuestionCircle,
  faSave,
  faSignOutAlt,
  faSortAmountDownAlt,
  faSortDown,
  faSortUp,
  faSquare,
  faStrikethrough,
  faTimes,
  faTimesCircle,
  faToggleOff,
  faToggleOn,
  faTrash,
  faUnderline,
  faUnlink,
  faUser,
  faUserFriends,
  faUserTie,
)

Vue.component('font-awesome-icon', FontAwesomeIcon)